module.exports = __webpack_public_path__ + "img/advantage_02.9de72c0f.png";